import { ACTION_CONSTANTS } from 'actions/constants';

const DEFAULT_STORE = {
  currentProjectId: null,
  projects: {}
};

const DEFAULT_PROJECT_SETTINGS = {};

if (!window.localStorage.settings) {
  window.localStorage.setItem('settings', JSON.stringify(DEFAULT_STORE));
} else {
  ensureAllFieldsPresent();
  ensureAllProjectFieldsPresent();
}

const INITIAL_STATE = JSON.parse(window.localStorage.settings);

export function localStorageSettings(state = INITIAL_STATE, action) {
  let newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case ACTION_CONSTANTS.localStorageSettings.setLocalStorageSettings:
      const target = action.payload.path[action.payload.path.length - 1];
      let currentDir = newState;
      action.payload.path.forEach((dir, i) => {
        if (i !== action.payload.path.length - 1) {
          currentDir = currentDir[dir];
        }
      });
      currentDir[target] = action.payload.data;
      window.localStorage.setItem('settings', JSON.stringify(newState));
      return newState;
    case ACTION_CONSTANTS.localStorageSettings.instantiateProjectStorage:
      const projectId = parseInt(action.payload.projectId, 10);
      if (!state.projects[projectId]) {
        newState.projects[projectId] = DEFAULT_PROJECT_SETTINGS;
        window.localStorage.setItem('settings', JSON.stringify(newState));
        return newState;
      } else {
        return state;
      }
    default:
      return state;
  }
}

function recursiveUpdate(state, defaultSettings) {
  for (let k in defaultSettings) {
    if (!state.hasOwnProperty(k)) {
      state[k] = defaultSettings[k];
    } else if (typeof defaultSettings[k] === 'object') {
      recursiveUpdate(state[k], defaultSettings[k]);
    }
  }
}

function ensureAllFieldsPresent() {
  const state = JSON.parse(window.localStorage.settings);
  recursiveUpdate(state, DEFAULT_STORE);
  localStorage.setItem('settings', JSON.stringify(state));
}

function ensureAllProjectFieldsPresent() {
  const state = JSON.parse(window.localStorage.settings);
  let { projects } = state;

  Object.keys(projects).forEach(projectId => {
    recursiveUpdate(projects[projectId], DEFAULT_PROJECT_SETTINGS);
  });
  state.projects = projects;
  localStorage.setItem('settings', JSON.stringify(state));
}



// WEBPACK FOOTER //
// ./src/reducers/localStorageSettings.js